import React from 'react';
import { Box } from 'oskcomponents';

const OSKHR = ({ ...props }: any) => (
    <Box className="oskhr" {...props} h={1} style={{ border: '1px solid', opacity: '0.1' }} grow />
);

export { OSKHR };
